/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import { DividerNew, Heading } from 'sarsaparilla';

import {
    CAMPING_TYPES,
    ELECTRIC_TYPE,
    VEHICLE_LENGTH_TYPE,
} from '../../../constants/filters/camping';
import { FiltersTypeProps } from '../../../types/filters';
import {
    countUiFilterSelections,
    getGroupCount,
    type UiFiltersState,
} from '../../../utils/filters';
import { CommonFilter } from './CommonFilter';
import { NumberFieldFilter } from './NumberFieldFilter';

interface CampsiteTypeFiltersProps {
    /** Selected filter groups */
    fg: string[];
    uiFilters: UiFiltersState;
    onChange: (
        event: React.ChangeEvent<HTMLInputElement>,
        item: FiltersTypeProps
    ) => void;
    onFilterGroupsChange: (fg: string[]) => void;
}

const FILTER_KEYS = [...CAMPING_TYPES, ...ELECTRIC_TYPE, VEHICLE_LENGTH_TYPE].map(
    (item) => item.key
);

/** Camping type, vehicle length and electricity filters */
export function CampsiteTypeFilters({
    fg,
    uiFilters,
    onChange,
    onFilterGroupsChange,
}: CampsiteTypeFiltersProps) {
    const campingCount =
        countUiFilterSelections(uiFilters, ['campsiteVehicleLength']) +
        getGroupCount(FILTER_KEYS, { fg });

    return (
        <div>
            <div className="search-filters-section-header rounded-layout">
                <Heading headingLevel={2} appearance="h5">
                    Select the Camping filters that work for you.
                </Heading>
                <span className="search-filters-section-header__count">
                    {campingCount} {campingCount === 1 ? 'Filter' : 'Filters'} Selected
                </span>
            </div>
            <div className="search-filters-filter-container">
                <CommonFilter
                    fg={fg}
                    filters={CAMPING_TYPES}
                    title="Camping Type"
                    onChange={onChange}
                    hasDivider={false}
                />
                <div className="pt-2">
                    <DividerNew />
                </div>
                <div className="pt-2">
                    <NumberFieldFilter
                        label={VEHICLE_LENGTH_TYPE.value}
                        id={VEHICLE_LENGTH_TYPE.key}
                        units="feet"
                        max={99}
                        filter={VEHICLE_LENGTH_TYPE.key}
                        unitAfter="ft"
                        fg={fg}
                        onFilterGroupsChange={onFilterGroupsChange}
                    />
                </div>
                <CommonFilter
                    fg={fg}
                    filters={ELECTRIC_TYPE}
                    title="Electricity"
                    onChange={onChange}
                    hasDivider={false}
                />
            </div>
        </div>
    );
}
